(function(){
  if(window.__sno3bbp)return;window.__sno3bbp=true;
  var root=document.querySelector('.sno3bbp');if(!root)return;
  var slotsWrap=document.getElementById('sno3bbp-slots');
  var progressEl=document.getElementById('sno3bbp-progress');
  var addBtn=document.getElementById('sno3bbp-add');
  var bar=document.getElementById('sno3bbp-bar');
  var fillEl=document.getElementById('sno3bbp-fill');
  var countEl=document.getElementById('sno3bbp-count');
  var barAdd=document.getElementById('sno3bbp-baradd');
  var mainImg=document.getElementById('sno3bbp-main');
  var drawer=document.getElementById('sno3bbp-drawer');
  var panelList=document.getElementById('sno3bbp-plist');
  var pillsWrap=document.getElementById('sno3bbp-pills');
  var searchInput=document.getElementById('sno3bbp-search');
  var ctaBtn=document.getElementById('sno3bbp-cta');

  var handle=root.getAttribute('data-collection')||'wax-melts';
  var target=parseInt(root.getAttribute('data-target'),10)||10;
  var unit=parseFloat(root.getAttribute('data-unit'))||2.95;
  var dealPrice=root.getAttribute('data-dealprice')||'';
  var savePrice=root.getAttribute('data-saveprice')||'';
  var pctOff=root.getAttribute('data-pctoff')||'';
  var noun=root.getAttribute('data-noun')||'melt'; var nounp=root.getAttribute('data-nounp')||'melts';

  var scentOrder=[]; var scentMap={};
  try{ (JSON.parse(document.getElementById('sno3bbp-scentmap').textContent)||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length===2){var lbl=p[0].trim();scentMap[lbl.toLowerCase()]=p[1].trim();scentOrder.push(lbl);}}); }catch(e){}

  var catalog=[];            // {id,title,fullTitle,img,scent,rating}
  var byId={};
  var counts={};             // variantId -> qty
  var order=[];              // variantId insertion order
  var activeFilter='';       // scent label (lowercase) or ''
  var activeQuery='';
  var ratingMap={};          // productId -> {r,n}
  try{ ratingMap=JSON.parse(document.getElementById('sno3bbp-ratings').textContent)||{}; }catch(e){}
  var addonCatalog=[]; var addonById={}; var addons={};   // addon variantId -> qty
  var addonsWrap=document.getElementById('sno3bbp-addons');
  var addonRow=document.getElementById('sno3bbp-addonrow');
  var addonCols=(root.getAttribute('data-addons')||'').split(',').map(function(s){return s.trim();}).filter(Boolean);

  function fetchJSON(u){ return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function priceFloat(v){ var n=parseFloat(v); if(!isFinite(n))return 0; return n>1000?n/100:n; }
  function ord(n){ var s=['th','st','nd','rd'],v=n%100; return n+(s[(v-20)%10]||s[v]||s[0]); }
  function thumb(src,w){ return src?src.replace(/(\.[a-z]+)(\?|$)/i,'_'+w+'x$1$2'):''; }
  function esc(s){ return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function money(v){ var n=parseFloat(v); if(!isFinite(n))return ''; if(n>1000)n=n/100; return '£'+n.toFixed(2); }
  function starsHTML(rt){ if(!rt||!rt.n)return ''; return '<span class="sno3bbp__stars">★ '+Number(rt.r).toFixed(1)+' <i>('+rt.n+')</i></span>'; }
  function shuffle(a){ for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=a[i];a[i]=a[j];a[j]=t;} return a; }

  function total(){ var t=0; order.forEach(function(id){t+=counts[id]||0;}); return t; }

  function rawAdd(id){ if(total()>=target)return; if(!(counts[id]>0)){counts[id]=0; if(order.indexOf(id)<0)order.push(id);} counts[id]++; }
  function quickFill(mode){
    if(mode==='clear'){ counts={}; order=[]; renderSlots(); renderList(); updateUI(); return; }
    if(total()>=target || !catalog.length)return;
    var pool=catalog.slice();
    if(mode==='best'){ pool.sort(function(a,b){ var an=(a.rating&&a.rating.n)||0,bn=(b.rating&&b.rating.n)||0; if(bn!==an)return bn-an; var ar=(a.rating&&a.rating.r)||0,br=(b.rating&&b.rating.r)||0; return br-ar; }); }
    else { shuffle(pool); }
    for(var k=0;k<pool.length && total()<target;k++){ rawAdd(pool[k].id); }
    renderSlots(); renderList(); updateUI();
  }

  function loadAddons(){
    if(!addonCols.length||!addonsWrap)return;
    Promise.all(addonCols.map(function(h){ return fetchJSON('/collections/'+h+'/products.json?limit=250').catch(function(){return {products:[]};}); })).then(function(res){
      var seen={};
      res.forEach(function(d){ (d.products||[]).forEach(function(p){
        var v=(p.variants&&p.variants[0])||null; if(!v||v.available===false||seen[p.id])return; seen[p.id]=1;
        var img=(p.images&&p.images[0]&&(p.images[0].src||p.images[0]))||(p.image&&p.image.src)||'';
        addonCatalog.push({id:v.id,title:p.title,img:img,price:v.price});
      }); });
      addonCatalog.forEach(function(a){addonById[a.id]=a;});
      addonCatalog=addonCatalog.slice(0,12);
      renderAddons();
      if(addonCatalog.length)addonsWrap.hidden=false;
    });
  }
  function addonBtnHTML(id){ return (addons[id]>0)?'<button type="button" class="sno3bbp__acbtn is-on" data-acadd="'+id+'">Added ✓</button>':'<button type="button" class="sno3bbp__acbtn" data-acadd="'+id+'">Add +</button>'; }
  function renderAddons(){
    if(!addonRow)return;
    addonRow.innerHTML=addonCatalog.map(function(a){
      return '<div class="sno3bbp__ac" data-ac="'+a.id+'"><img src="'+thumb(a.img,120)+'" alt="" width="60" height="60" loading="lazy">'+
        '<p class="sno3bbp__acname">'+esc(a.title)+'</p><span class="sno3bbp__acprice">'+money(a.price)+'</span>'+
        '<span class="sno3bbp__acctrl" data-acctrl="'+a.id+'">'+addonBtnHTML(a.id)+'</span></div>';
    }).join('');
  }

  function load(){
    var subs=scentOrder.map(function(label){
      var h=scentMap[label.toLowerCase()];
      return fetchJSON('/collections/'+h+'/products.json?limit=250')
        .then(function(d){return {label:label,ids:(d.products||[]).map(function(p){return p.id;})};})
        .catch(function(){return {label:label,ids:[]};});
    });
    Promise.all([fetchJSON('/collections/'+handle+'/products.json?limit=250').catch(function(){return {products:[]};})].concat(subs)).then(function(res){
      var main=res[0].products||[]; var scentById={};
      res.slice(1).forEach(function(r){r.ids.forEach(function(id){scentById[id]=r.label;});});
      catalog=main.filter(function(p){
        var v=(p.variants&&p.variants[0])||null; if(!v)return false;
        var tags=(p.tags||[]).join(' ').toLowerCase(); var t=(p.title||'').toLowerCase();
        var isBundle=tags.indexOf('easy-bundle')>-1 || /bundle|pick your perfect|mystery|subscription|save 20/.test(t);
        return !isBundle && Math.abs(priceFloat(v.price)-unit)<0.011 && v.available!==false;
      }).map(function(p){
        var img=(p.images&&p.images[0]&&(p.images[0].src||p.images[0]))||(p.image&&p.image.src)||'';
        return {id:p.variants[0].id,title:p.title.replace(/\s+wax melt$/i,''),fullTitle:p.title,img:img,scent:scentById[p.id]||'',rating:ratingMap[p.id]||null};
      });
      catalog.forEach(function(p){byId[p.id]=p;});
      catalog.sort(function(a,b){return a.title.localeCompare(b.title);});
      buildPills();
      renderSlots();
      renderList();
      updateUI();
    });
  }

  /* ---------- buy-box slots ---------- */
  function flatIds(){ var f=[]; order.forEach(function(id){ var q=counts[id]||0; for(var k=0;k<q;k++)f.push(id); }); return f; }

  function slotHTML(i,id){
    if(id && byId[id]){
      var p=byId[id];
      return '<div class="sno3bbp__slot is-filled" data-slot="'+i+'">'+
        '<span class="sno3bbp__slotn">'+ord(i+1)+'</span>'+
        '<span class="sno3bbp__chip"><img src="'+thumb(p.img,80)+'" alt="" width="40" height="40">'+
        '<span class="sno3bbp__chipname">'+esc(p.title)+'</span>'+
        '<button type="button" class="sno3bbp__clear" data-rm="'+id+'" aria-label="Remove '+esc(p.title)+'">&times;</button></span></div>';
    }
    return '<button type="button" class="sno3bbp__slot sno3bbp__slot--empty" data-open aria-label="Choose your '+ord(i+1)+' '+noun+'">'+
      '<span class="sno3bbp__slotn">'+ord(i+1)+'</span>'+
      '<span class="sno3bbp__slotcta"><span class="sno3bbp__plus">+</span> Search &amp; choose a '+noun+'…</span></button>';
  }
  function renderSlots(){
    if(!catalog.length){ slotsWrap.innerHTML='<p class="sno3bbp__state">Couldn’t load the scents. Please refresh.</p>'; return; }
    var flat=flatIds(); var html='';
    for(var i=0;i<target;i++){ html+=slotHTML(i, flat[i]); }
    slotsWrap.innerHTML=html;
  }

  /* ---------- drawer ---------- */
  function buildPills(){
    var pills='<button type="button" class="sno3bbp__pill is-on" data-filter="">All</button>';
    scentOrder.forEach(function(label){ pills+='<button type="button" class="sno3bbp__pill" data-filter="'+esc(label.toLowerCase())+'">'+esc(label)+'</button>'; });
    pillsWrap.innerHTML=pills;
  }

  function cardAddHTML(id){
    var q=counts[id]||0; var full=total()>=target;
    if(q>0){
      return '<div class="sno3bbp__step"><button type="button" class="sno3bbp__stepb" data-dec="'+id+'" aria-label="Remove one">&minus;</button>'+
        '<span class="sno3bbp__stepn">'+q+'</span>'+
        '<button type="button" class="sno3bbp__stepb" data-inc="'+id+'"'+(full?' disabled':'')+' aria-label="Add one">+</button></div>';
    }
    return '<button type="button" class="sno3bbp__cardadd" data-inc="'+id+'"'+(full?' disabled':'')+'>Add +</button>';
  }

  function renderList(){
    var q=activeQuery, f=activeFilter;
    var list=catalog.filter(function(p){
      if(f && (p.scent||'').toLowerCase()!==f) return false;
      if(q && p.fullTitle.toLowerCase().indexOf(q)<0) return false;
      return true;
    });
    if(!list.length){ panelList.innerHTML='<p class="sno3bbp__nomatch">No '+nounp+' match that.</p>'; return; }
    panelList.innerHTML=list.map(function(p){
      return '<div class="sno3bbp__card'+((counts[p.id]||0)>0?' is-added':'')+'" data-card="'+p.id+'">'+
        '<img class="sno3bbp__cardimg" src="'+thumb(p.img,120)+'" alt="" width="56" height="56" loading="lazy">'+
        '<div class="sno3bbp__cardbody"><p class="sno3bbp__cardname">'+esc(p.title)+'</p>'+
          '<div class="sno3bbp__cardmeta">'+starsHTML(p.rating)+(p.scent?'<span class="sno3bbp__tag">'+esc(p.scent)+'</span>':'')+'</div></div>'+
        '<div class="sno3bbp__cardctrl" data-ctrl="'+p.id+'">'+cardAddHTML(p.id)+'</div></div>';
    }).join('');
  }
  function refreshCard(id){
    var ctrl=panelList.querySelector('[data-ctrl="'+id+'"]'); if(ctrl)ctrl.innerHTML=cardAddHTML(id);
    var card=panelList.querySelector('[data-card="'+id+'"]'); if(card)card.classList.toggle('is-added',(counts[id]||0)>0);
  }
  function refreshAllAddStates(){
    var full=total()>=target;
    panelList.querySelectorAll('[data-inc]').forEach(function(b){ b.disabled=full; });
  }

  function openDrawer(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; setTimeout(function(){ if(searchInput)searchInput.focus(); },60); }
  function closeDrawer(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }

  function addOne(id){ if(total()>=target)return; if(!(counts[id]>0)){counts[id]=0; if(order.indexOf(id)<0)order.push(id);} counts[id]++; afterChange(id); }
  function removeOne(id){ if(!(counts[id]>0))return; counts[id]--; if(counts[id]<=0){ delete counts[id]; var ix=order.indexOf(id); if(ix>-1)order.splice(ix,1);} afterChange(id); }

  function afterChange(id){ renderSlots(); refreshCard(id); refreshAllAddStates(); updateUI(); }

  function updateUI(){
    var n=total(); var left=target-n; var full=n>=target;
    progressEl.textContent=n+' / '+target;
    var pct=Math.round(n/target*100); fillEl.style.width=pct+'%';
    if(full){ bar.classList.add('is-ready'); } else { bar.classList.remove('is-ready'); }
    var unlock=(savePrice?(' to unlock '+pctOff+'% off'):'');
    addBtn.textContent=full?('Add to basket → save '+savePrice):(n===0?('Choose your '+target+' '+nounp):(left+' more'+unlock));
    ctaBtn.disabled=!full;
    ctaBtn.textContent=full?('Add to basket '+dealPrice+' · save '+savePrice):('Add '+left+' more'+unlock);
    barAdd.textContent=full?('Add · save '+savePrice):(n===0?('Choose '+nounp):(left+unlock));
    countEl.innerHTML='<b>'+n+' of '+target+'</b> '+nounp+' chosen';
  }

  /* ---------- events ---------- */
  slotsWrap.addEventListener('click',function(e){
    var open=e.target.closest('[data-open]'); if(open){ openDrawer(); return; }
    var rm=e.target.closest('[data-rm]'); if(rm){ removeOne(parseInt(rm.getAttribute('data-rm'),10)); return; }
  });
  pillsWrap.addEventListener('click',function(e){
    var pill=e.target.closest('.sno3bbp__pill'); if(!pill)return;
    activeFilter=pill.getAttribute('data-filter')||'';
    pillsWrap.querySelectorAll('.sno3bbp__pill').forEach(function(x){x.classList.remove('is-on');});
    pill.classList.add('is-on'); renderList();
  });
  searchInput.addEventListener('input',function(){ activeQuery=(searchInput.value||'').trim().toLowerCase(); renderList(); });
  var quickWrap=document.querySelector('.sno3bbp__quick');
  if(quickWrap)quickWrap.addEventListener('click',function(e){ var b=e.target.closest('[data-qf]'); if(b)quickFill(b.getAttribute('data-qf')); });
  if(addonRow)addonRow.addEventListener('click',function(e){ var b=e.target.closest('[data-acadd]'); if(!b)return; var id=b.getAttribute('data-acadd'); addons[id]=addons[id]>0?0:1; var c=addonRow.querySelector('[data-acctrl="'+id+'"]'); if(c)c.innerHTML=addonBtnHTML(id); var card=addonRow.querySelector('[data-ac="'+id+'"]'); if(card)card.classList.toggle('is-on',addons[id]>0); });
  panelList.addEventListener('click',function(e){
    var inc=e.target.closest('[data-inc]'); if(inc && !inc.disabled){ addOne(parseInt(inc.getAttribute('data-inc'),10)); return; }
    var dec=e.target.closest('[data-dec]'); if(dec){ removeOne(parseInt(dec.getAttribute('data-dec'),10)); return; }
  });
  drawer.addEventListener('click',function(e){ if(e.target.closest('[data-close]')) closeDrawer(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  function doAdd(btn){
    if(total()<target)return;
    var items=order.map(function(id){ return {id:id,quantity:counts[id]}; }).filter(function(x){return x.quantity>0;});
    Object.keys(addons).forEach(function(aid){ if(addons[aid]>0)items.push({id:parseInt(aid,10),quantity:addons[aid]}); });
    if(!items.length)return;
    var orig=btn.textContent; btn.disabled=true; btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ window.location.href='/cart'; })
      .catch(function(){ btn.textContent=orig; btn.disabled=false; alert('Sorry, something went wrong adding your bundle. Please try again.'); });
  }
  addBtn.addEventListener('click',function(){ if(total()>=target){ doAdd(addBtn); } else { openDrawer(); } });
  barAdd.addEventListener('click',function(){ if(total()>=target){ doAdd(barAdd); } else { openDrawer(); } });
  ctaBtn.addEventListener('click',function(){ if(total()>=target){ closeDrawer(); doAdd(ctaBtn); } });

  document.querySelectorAll('.sno3bbp__thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.sno3bbp__thumb').forEach(function(x){x.classList.remove('is-sel');});
      t.classList.add('is-sel'); if(mainImg)mainImg.src=t.getAttribute('data-full');
    });
  });

  load();
  loadAddons();
})();
